export default __webpack_public_path__ + "static/media/home-web-agency-img-03.050153c8.jpg";